exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containers[data-v-21858a54] {\n  height: 100%;\n}\n/*\n * @author: 张志成\n * @description: 变量\n */\n", ""]);

// exports
